import { Page, View, Image, Text } from '@react-pdf/renderer';
import { styles } from './styles';
import {
  Portfolio,
  PublicEventDetailsResponse,
  ResponsePaginationType,
} from '@hubs101/booking-api-skd-client/lib/types';
import bgImage from '@assets/images/speaker_image_1.jpg';

export interface IntermediatePageProps {
  event: PublicEventDetailsResponse;
  coLocatedEvents: PublicEventDetailsResponse[] | undefined;
  portfolios: ResponsePaginationType<Portfolio> | undefined;
  header: JSX.Element;
  footer: JSX.Element;
}

const IntermediatePage = ({
  event,
  coLocatedEvents,
  portfolios,
  header,
  footer,
}: IntermediatePageProps) => {
  return (
    <Page size="A4" orientation="portrait" style={styles.page}>
      <View style={styles.backgroundContainer}>
        <Image src={bgImage} style={styles.backgroundImage} />

        <View>{header}</View>

        <View style={styles.overlayContent}>
          <Text style={styles.title}>
            {'„Good arrangements and nice line up of speakers.“'}
          </Text>
          <Text style={styles.subtitle}>
            {'Vehicle und Automations Experte'}
          </Text>
          <Text style={styles.subtitle}>{'Bishop Consulting'}</Text>
        </View>
      </View>

      {footer}
    </Page>
  );
};

export default IntermediatePage;
